import { STUDY_STATUS_COLOR } from '@patsnap/synapse_common_config'
import { defineComponent } from '@vue/composition-api'
import { ElTag } from '../../../../element-ui'
import { BDecodeUniCodeContainer } from '../../BDecodeUniCodeContainer/BDecodeUniCodeContainer'
import './BStatusTag.scss'

export const BStatusTag = defineComponent({
  props: {
    status: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'small',
    },
    fontSize: {
      type: Number,
      default: 14,
    },
    fontClassName: {
      type: String,
    },
    colorConfig: {
      type: Object as () => Record<string, { bg: string; text: string }>,
      default: () => STUDY_STATUS_COLOR,
    },
  },
  render() {
    return (
      <ElTag
        class="b-status-tag"
        size={this.size}
        disable-transitions={true}
        effect="dark"
        color={this.colorConfig[this.status as keyof typeof this.colorConfig]?.bg || '#F8E5CE'}
        style={{ color: this.colorConfig[this.status as keyof typeof this.colorConfig]?.text || '#764407', fontSize: `${this.fontSize}px` }}
      >
        {this.$slots.default ? (
          this.$slots.default
        ) : (
          <BDecodeUniCodeContainer fontClassName={this.fontClassName} domPropsInnerHTML={this.status}></BDecodeUniCodeContainer>
        )}
      </ElTag>
    )
  },
})
